import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e7e1b87&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7e7e1b87&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7e1b87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/live-front-end_XotX/plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7e1b87')) {
      api.createRecord('7e7e1b87', component.options)
    } else {
      api.reload('7e7e1b87', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7e7e1b87&scoped=true", function () {
      api.rerender('7e7e1b87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DictTag/index.vue"
export default component.exports